import { addDays, isSameDay } from "date-fns";

export function getAvailableDays(range: { startDate: Date; endDate: Date }) {
  const today = new Date();
  const availableDates: Date[] = [];
  for (
    let index = range.startDate;
    index < range.endDate;
    index = addDays(index, 1)
  ) {
    if (isSameDay(index, today) || index > today) {
      availableDates.push(index);
    }
  }

  return availableDates;
}
